export const ONLINE_CE_FILTERS = [
  {
    id: "online_ce_btn",
    name: "Online CE Reporting",
    navigateTo: "/digital_performance",
  },
  {
    id: "cpo_online_btn",
    name: "CPO Online CE",
    navigateTo: "/cpo_digital_performance",
  },
  {
    id: "jounrey_btn",
    name: "Journey Excellence",
    navigateTo: "/journey_excellence/market_performance_summary",
    hide_on_mobile: false,
  },
  {
    id: "oce_digital_trend_btn",
    name: "OCE Digital Trend",
    navigateTo: "/oce_digital_trend",
  },
];

// Looker Studio (formerly Data Studio) embed for the OCE Digital Trend page - a straight iframe
// embed, same as Global M&S's own LookStudioEmbeddedLinks (globalMSSalesConstants.ts), just kept
// alongside ONLINE_CE_FILTERS since this is the only Looker-embedded page in the Online CE family.
export const OCE_DIGITAL_TREND_LOOKER_URL =
  "https://datastudio.google.com/embed/reporting/29b6145a-3c56-49d2-8cd6-d80e91dffd0b/page/p_cn9qe1xd3d";

export const ECOMMERCE_FILTERS = [
  {
    id: "ecommerce_btn",
    name: "Ecommerce",
    navigateTo: "/ecommerce",
  },
  {
    id: "cpo_operational_btn",
    name: "CPO Operational",
    navigateTo: "/cpo_operational",
  },
];
